const API_ENDPOINTS = {
    NEWSLETTER_CONTENT: '/home/newsletter',
};

const SELECTORS = {
    NEWSLETTER_CONTAINER: "divNewsletter"
};

class NewsletterLoader {
    constructor() {
        this.divNewsletter = document.getElementById(SELECTORS.NEWSLETTER_CONTAINER);
        this.options = null;
        this.observer = null;
    }

    init = () => {
        this.observer = new IntersectionObserver(this.callBack, this.options);
        if (this.divNewsletter)
            this.setUpObserve(this.divNewsletter);
    };

    setUpObserve = container => {
        this.options = { root: container, threshold: 0.9 }; // 0.9 instead of 1 for safari fix
        this.observer.observe(container);
    };

    // Callback function for the Intersection Observer
    callBack = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                if (entry.target.id === SELECTORS.NEWSLETTER_CONTAINER) {
                    this.getNewsletterSection();
                    observer.unobserve(entry.target);
                }
            }
        });
    };

    getNewsletterSection = async () => {
        var loading = '<div id="newsletterLoading" class="spinner" role="alert" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
        this.divNewsletter.innerHTML = loading;

        try{
            const response = await fetch(API_ENDPOINTS.NEWSLETTER_CONTENT, {
                method: 'GET',
                headers: { 'X-Requested-With': 'fetch' }
            });
            //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
            const responseHTML = await response.text();
            this.divNewsletter.innerHTML = responseHTML;
            var head = document.getElementsByTagName('head')[0];
            script = document.createElement('script');
            script.src = document.getElementById('newsletterPath').value;
            script.id = 'newsletter23js'
            script.type = 'text/javascript';
            script.async = true;
            script.setAttribute('crossorigin', 'anonymous');
            head.appendChild(script);
        }catch(error){
            console.error(error);
            this.divNewsletter.innerHTML = '';
        }
    };
}

export default new NewsletterLoader();